export default __webpack_public_path__ + "static/media/placeholder_dummy2016-anwaltskanzlei01-mobile-de.fb0925e8.png";